// extracted by mini-css-extract-plugin
export default {"status":"ResourceStatus_status__dbHBm","icon":"ResourceStatus_icon__ORIUT","label":"ResourceStatus_label__JZwoo"};